<template>
  <v-container>
    <alert :type="alertType" @closealert="closeAlert" :alertShow="alertShow" :msg="alertMsg"></alert>
    <list-devType
      v-if="choosenDeviceType==null && path==''"
      @choosendeviceType="showChoosenDeviceType"
    ></list-devType>
    <manage-user
      v-if="choosenDeviceType!=null && path=='manageUser'"
      :choosenDeviceType="choosenDeviceType"
      @back="backinfo"
    ></manage-user>
    <info-devType
      v-if="choosenDeviceType!=null && path=='info'"
      :choosenDeviceType="choosenDeviceType"
      @back="back"
      @edit="editDeviceType"
      @error="error"
      @saved="saved"
      @user="editUserInDeviceType"
      @clickmarker="clickmarker"
      @dataAndAlert="manageDataAndAlert"
      @addMqtt="createMqtt"
      @updateMqtt="updateMqtt"
    ></info-devType>
    <edit-devType
      v-if="(path=='edit')"
      :choosenDeviceType="choosenDeviceType"
      :path="path"
      @backinfo="backinfo"
      @error="error"
      @saved="saved"
    ></edit-devType>
    <managealert
      v-if="(path=='manageDataAndAlert')"
      :choosenDeviceType="choosenDeviceType"
      :path="path"
      @updateAlert="updateAlert"
      @createAlert="createAlert"
      @back="backinfo"
    ></managealert>
    <setMqtt
      v-if="(path=='createMqtt') || (path=='updateMqtt')"
      :choosenDeviceType="choosenDeviceType"
      :deviceTypeMqtt="deviceTypeMqtt"
      :path="path"
      @saved="mqttSaved"
      @back="backinfo"
    ></setMqtt>
    <setalert
      v-if="(path=='createAlert') || (path=='updateAlert')"
      :choosenDeviceType="choosenDeviceType"
      :deviceTypeAlert="deviceTypeAlert"
      :path="path"
      @saved="alertSaved"
      @back="backManage"
    ></setalert>
    <create-devType v-if="(path=='create')" :path="path" @back="back" @error="error" @saved="saved"></create-devType>
    <v-row v-if="path==''">
      <v-col class="text-center">
        <v-btn class="ma-2" tile outlined color="primary" @click="createDeviceType">
          <v-icon left>mdi-plus-circle</v-icon>
          {{$t('DeviceTypes.create')}}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import ListDeviceTypesComponent from "./ListDeviceTypes";
import CreateDeviceTypeComponent from "./CreateDeviceType";
import AlertComponent from "./Alert.vue";
import DeviceTypeInfoComponent from "./DeviceTypeInfo";
import EditDeviceTypeComponent from "./EditDeviceType";
import ManageUserInDeviceTypeComponent from "./ManageUserInDeviceType";
import ManageAlertComponent from "./ManageAlert";
import SetAlertComponent from "./SetAlert";
import SetMqttComponent from "./SetMqtt";

export default {
  props: {
    changedPath: String
  },
  components: {
    "list-devType": ListDeviceTypesComponent,
    "create-devType": CreateDeviceTypeComponent,
    "edit-devType": EditDeviceTypeComponent,
    alert: AlertComponent,
    "info-devType": DeviceTypeInfoComponent,
    "manage-user": ManageUserInDeviceTypeComponent,
    managealert: ManageAlertComponent,
    setalert: SetAlertComponent,
    setMqtt: SetMqttComponent
  },

  data: () => ({
    choosenDeviceType: null,
    path: "",
    alertMsg: "",
    alertType: "error",
    alertShow: false,
    deviceTypeAlert: null,
    deviceTypeMqtt: null
  }),
  methods: {
    updateMqtt(mqtt) {
      this.deviceTypeMqtt = mqtt;
      this.path = "updateMqtt";
      this.$emit("subpath", [
        { name: this.choosenDeviceType.name, subpath: "devTypeInfo" },
        {
          name: mqtt.url + ":" + mqtt.port,
          subpath: "updateMqtt"
        }
      ]);
    },
    createMqtt() {
      this.deviceTypeMqtt = {};
      this.path = "createMqtt";
      this.$emit("subpath", [
        { name: this.choosenDeviceType.name, subpath: "devTypeInfo" },
        {
          name: this.$t("DeviceTypes.createMqtt"),
          subpath: "createMqtt"
        }
      ]);
    },

    updateAlert(alert) {
      this.deviceTypeAlert = alert;
      this.path = "updateAlert";
      this.$emit("subpath", [
        { name: this.choosenDeviceType.name, subpath: "devTypeInfo" },
        {
          name: this.$t("DeviceTypes.manageDataAndAlert"),
          subpath: "manageDataAndAlert"
        },
        {
          name: alert.name,
          subpath: "updateAlert"
        }
      ]);
    },
    createAlert() {
      this.deviceTypeAlert = {};
      this.path = "createAlert";
      this.$emit("subpath", [
        { name: this.choosenDeviceType.name, subpath: "devTypeInfo" },
        {
          name: this.$t("DeviceTypes.manageDataAndAlert"),
          subpath: "manageDataAndAlert"
        },
        {
          name: this.$t("DeviceTypes.createAlert"),
          subpath: "createAlert"
        }
      ]);
    },
    showChoosenDeviceType: function(value) {
      this.choosenDeviceType = value;
      this.path = "info";
      this.$emit("subpath", [
        { name: this.choosenDeviceType.name, subpath: "devTypeInfo" }
      ]);
    },
    createDeviceType: function() {
      this.path = "create";
      this.$emit("subpath", [
        { name: this.$t("DeviceTypes.create"), subpath: "create" }
      ]);
    },
    manageDataAndAlert: function() {
      this.path = "manageDataAndAlert";
      this.$emit("subpath", [
        { name: this.choosenDeviceType.name, subpath: "devTypeInfo" },
        {
          name: this.$t("DeviceTypes.manageDataAndAlert"),
          subpath: "manageDataAndAlert"
        }
      ]);
    },
    editDeviceType: function() {
      this.path = "edit";
      this.$emit("subpath", [
        { name: this.choosenDeviceType.name, subpath: "devTypeInfo" },
        {
          name: this.$t("DeviceTypes.edit"),
          subpath: "edit"
        }
      ]);
    },
    editUserInDeviceType: function() {
      this.path = "manageUser";
      this.$emit("subpath", [
        { name: this.choosenDeviceType.name, subpath: "devTypeInfo" },
        {
          name: this.$t("DeviceTypes.manage"),
          subpath: "manageUser"
        }
      ]);
    },
    back: function() {
      this.choosenDeviceType = null;
      this.path = "";
      this.$emit("subpath", [""]);
      window.scrollTo(0, 0);
    },
    backinfo: function() {
      this.path = "info";
      this.$emit("subpath", [
        { name: this.choosenDeviceType.name, subpath: "devTypeInfo" }
      ]);
      window.scrollTo(0, 0);
    },
    backManage: function() {
      this.path = "manageDataAndAlert";
      this.$emit("subpath", [
        { name: this.choosenDeviceType.name, subpath: "devTypeInfo" },
        {
          name: this.$t("DeviceTypes.manageDataAndAlert"),
          subpath: "manageDataAndAlert"
        }
      ]);
      window.scrollTo(0, 0);
    },
    error: function(value) {
      this.alertMsg = value;
      this.alertType = "error";
      this.alertShow = true;
    },
    saved: function(value) {
      this.alertMsg = value;
      this.alertType = "success";
      this.alertShow = true;
      this.path = "";
      this.choosenDeviceType = null;
      this.$emit("subpath", [""]);
    },
    alertSaved: function(value) {
      this.alertMsg = value;
      this.alertType = "success";
      this.alertShow = true;
      this.path = "manageDataAndAlert";
      this.$emit("subpath", [
        { name: this.choosenDeviceType.name, subpath: "devTypeInfo" },
        {
          name: this.$t("DeviceTypes.manageDataAndAlert"),
          subpath: "manageDataAndAlert"
        }
      ]);
      window.scrollTo(0, 0);
    },
    mqttSaved: function(value) {
      this.alertMsg = value;
      this.alertType = "success";
      this.alertShow = true;
      this.path = "info";
      this.$emit("subpath", [
        { name: this.choosenDeviceType.name, subpath: "devTypeInfo" }
      ]);
      window.scrollTo(0, 0);
    },
    closeAlert: function() {
      this.alertShow = false;
    },
    clickmarker: function(value) {
      this.$emit("clickmarker", value);
    }
  },
  watch: {
    changedPath: function(value) {
      if (value == "deviceTypes") {
        this.back();
      } else if (value == "devTypeInfo") this.backinfo();
      else if (value == "manageDataAndAlert") this.backManage();
    }
  }
};
</script>